import type { CollectionItemStatus } from "../api/types";

// External Intake & Collection v1.0 PR 4 §2.2 — plain-language mapping of
// the item state machine. Spec is explicit: the recipient sees friendly
// labels, never the raw enum.

export interface StatusDisplay {
  label: string;
  tone: "neutral" | "progress" | "warn" | "ok" | "muted";
  /** Short, action-oriented sentence shown beneath the status pill. */
  description: string;
}

const MAP: Record<CollectionItemStatus, StatusDisplay> = {
  Pending: {
    label: "To do",
    tone: "neutral",
    description: "Open this item when you're ready to provide it.",
  },
  InProgress: {
    label: "In progress",
    tone: "progress",
    description: "We saved your place — pick up where you left off.",
  },
  SubmittedForReview: {
    label: "Under review",
    tone: "progress",
    description: "We received this and will let you know if anything is needed.",
  },
  ChangesRequested: {
    label: "Needs changes",
    tone: "warn",
    description: "Please review the comment and resubmit.",
  },
  Approved: {
    label: "Approved",
    tone: "ok",
    description: "Thanks — this item is complete.",
  },
  Waived: {
    label: "No longer needed",
    tone: "muted",
    description: "We don't need this item anymore. Nothing for you to do.",
  },
};

export function getItemStatusDisplay(status: CollectionItemStatus): StatusDisplay {
  return MAP[status];
}

export function isCompletedStatus(status: CollectionItemStatus): boolean {
  return status === "Approved" || status === "Waived";
}

export function isEditableStatus(status: CollectionItemStatus): boolean {
  return status === "Pending" || status === "InProgress" || status === "ChangesRequested";
}
